/*
 * File: deliveryAddressCityFilter.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 30 Dec 2021 11:59:58 am
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterCity } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

/* ****************** Interfaces ****************** */
interface Props {
  isDisabled?: boolean;
}

export const DeliveryAddressCityFilter = ({ isDisabled }: Props): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((event: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterCity(event.target.value));
  }, 500);

  useEffect(() => {
    return (): void => {
      dispatch(setFilterCity(undefined));
    };
  }, [dispatch]);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} width={150} disabled={isDisabled} placeholder="City" />
    </Space>
  );
};
